module.exports = __webpack_public_path__ + "media/images/icons/markerIcon-7eaad79f8ef66d33c499aabf29e4ed88.svg";